import React from 'react';
import { Bell, Plus, Send, Plane, Smartphone, ArrowUpRight, ArrowDownLeft, ShoppingBag, Car } from 'lucide-react';
import { Card } from '../components/ui/Card';
interface HomeScreenProps {
  onNavigate: (screen: string) => void;
  onTopUp: () => void;
}
export function HomeScreen({
  onNavigate,
  onTopUp
}: HomeScreenProps) {
  const transactions = [{
    id: 1,
    name: 'Carrefour Market',
    amount: -15000,
    date: "Aujourd'hui, 10h23",
    icon: ShoppingBag,
    type: 'debit'
  }, {
    id: 2,
    name: 'Rechargement Orange Money',
    amount: 50000,
    date: 'Hier',
    icon: ArrowDownLeft,
    type: 'credit'
  }, {
    id: 3,
    name: 'Uber Dakar',
    amount: -3500,
    date: 'Hier',
    icon: Car,
    type: 'debit'
  }, {
    id: 4,
    name: 'Transfert Wave',
    amount: -25000,
    date: '24 Oct',
    icon: Send,
    type: 'debit'
  }, {
    id: 5,
    name: 'Auchan',
    amount: -8200,
    date: '23 Oct',
    icon: ShoppingBag,
    type: 'debit'
  }];
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-338">
      {/* Header */}
      <header className="bg-[#003366] px-6 pt-12 pb-8 sticky top-0 z-10" data-id="element-339">
        <div className="flex justify-between items-center mb-6" data-id="element-340">
          <div className="flex items-center gap-2" data-id="element-341">
            <div className="w-8 h-8 bg-[#D4A017] rounded-lg flex items-center justify-center text-white font-bold text-sm" data-id="element-342">
              AL
            </div>
            <span className="font-bold text-xl text-white" data-id="element-343">ALAL</span>
          </div>
          <button className="p-2 text-white/80 hover:bg-white/10 rounded-full transition-colors relative" data-id="element-344">
            <Bell size={24} data-id="element-345" />
            <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-[#003366]" data-id="element-346"></span>
          </button>
        </div>

        <div className="space-y-1" data-id="element-347">
          <p className="text-sm font-medium text-white/70" data-id="element-348">Solde disponible</p>
          <h1 className="text-4xl font-bold text-white tracking-tight" data-id="element-349">
            450 000{' '}
            <span className="text-2xl text-white/60 font-normal" data-id="element-350">FCFA</span>
          </h1>
        </div>
      </header>

      <div className="px-6 py-6 space-y-8 -mt-4" data-id="element-351">
        {/* Quick Actions */}
        <div className="grid grid-cols-4 gap-4" data-id="element-352">
          <button onClick={onTopUp} className="flex flex-col items-center gap-2 group" data-id="element-353">
            <div className="w-14 h-14 bg-[#D4A017] text-white rounded-2xl flex items-center justify-center shadow-lg shadow-[#D4A017]/20 group-active:scale-95 transition-transform" data-id="element-354">
              <Plus size={24} data-id="element-355" />
            </div>
            <span className="text-xs font-medium text-gray-700" data-id="element-356">Recharger</span>
          </button>

          <button className="flex flex-col items-center gap-2 group" data-id="element-357">
            <div className="w-14 h-14 bg-white text-[#003366] border border-gray-100 rounded-2xl flex items-center justify-center shadow-sm group-active:scale-95 transition-transform" data-id="element-358">
              <Send size={24} data-id="element-359" />
            </div>
            <span className="text-xs font-medium text-gray-700" data-id="element-360">Payer</span>
          </button>

          <button onClick={() => onNavigate('flight-search')} className="flex flex-col items-center gap-2 group" data-id="element-361">
            <div className="w-14 h-14 bg-white text-[#003366] border border-gray-100 rounded-2xl flex items-center justify-center shadow-sm group-active:scale-95 transition-transform" data-id="element-362">
              <Plane size={24} data-id="element-363" />
            </div>
            <span className="text-xs font-medium text-gray-700" data-id="element-364">Vols</span>
          </button>

          <button onClick={() => onNavigate('esim')} className="flex flex-col items-center gap-2 group" data-id="element-365">
            <div className="w-14 h-14 bg-white text-[#003366] border border-gray-100 rounded-2xl flex items-center justify-center shadow-sm group-active:scale-95 transition-transform" data-id="element-366">
              <Smartphone size={24} data-id="element-367" />
            </div>
            <span className="text-xs font-medium text-gray-700" data-id="element-368">eSIM</span>
          </button>
        </div>

        {/* Insights */}
        <div className="bg-[#003366] rounded-2xl p-4 flex items-center justify-between text-white shadow-lg" data-id="element-369">
          <div className="flex items-center gap-3" data-id="element-370">
            <div className="p-2 bg-white/10 rounded-lg" data-id="element-371">
              <ArrowUpRight size={20} className="text-[#D4A017]" data-id="element-372" />
            </div>
            <div data-id="element-373">
              <p className="text-xs text-white/60" data-id="element-374">Dépenses ce mois</p>
              <p className="font-bold" data-id="element-375">125 000 FCFA</p>
            </div>
          </div>
          <div className="h-8 w-[1px] bg-white/10" data-id="element-376"></div>
          <div className="text-xs font-medium text-[#D4A017]" data-id="element-377">
            Voir les stats
          </div>
        </div>

        {/* Recent Transactions */}
        <div data-id="element-378">
          <div className="flex justify-between items-center mb-4" data-id="element-379">
            <h2 className="text-lg font-bold text-[#003366]" data-id="element-380">
              Activité récente
            </h2>
            <button className="text-sm font-medium text-[#D4A017]" data-id="element-381">
              Tout voir
            </button>
          </div>

          <div className="space-y-3" data-id="element-382">
            {transactions.map(tx => <Card key={tx.id} className="flex items-center justify-between p-4 active:bg-gray-50 transition-colors" data-id="element-383">
                <div className="flex items-center gap-4" data-id="element-384">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${tx.type === 'credit' ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600'}`} data-id="element-385">
                    <tx.icon size={20} data-id="element-386" />
                  </div>
                  <div data-id="element-387">
                    <h3 className="font-semibold text-gray-900 text-sm" data-id="element-388">
                      {tx.name}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-389">{tx.date}</p>
                  </div>
                </div>
                <span className={`font-medium text-sm ${tx.type === 'credit' ? 'text-green-600' : 'text-gray-900'}`} data-id="element-390">
                  {tx.type === 'credit' ? '+' : ''}
                  {tx.amount.toLocaleString('fr-FR')} FCFA
                </span>
              </Card>)}
          </div>
        </div>
      </div>
    </div>;
}